import { useState } from "react";
import { Box, Stack } from "@mui/material";
import { useLocation } from 'react-router-dom';
import NavBar from "../componentes/NavBar";
import MainConstestaciones from "../contestaciones/Main";
import LeftContestaciones from "../contestaciones/Left";
import RightContestaciones from "../contestaciones/Right";
import RightGeneral from "../general/Right";
import MainInicio from "../inicio/Main";
import { SelectedRowsProvider } from "../componentes/tabla/SelectedRowsContext";
import '../estilo/App.css';

const MainLayout = () => {
  const location = useLocation();
  const [view, setView] = useState(localStorage.getItem('view') || '');
  const [signal, setSignal] = useState(0);
  
  const handleSignal = async () => {
    setSignal((prevSignal) => prevSignal + 1);
  };
  const funcionVista = async () => {
    setView(localStorage.getItem('view'));
  };
  const getPageData = (pathname) => {
    switch (pathname) {
      case '/home':
        return {
          mainContent: <MainInicio/>,
          sidebarContent: <Box className="box-left1"></Box>,
          rightContent: <Box className="box-left1"></Box>
        };
      case '/dashboard':
        return {
          mainContent: <MainConstestaciones/>,
          sidebarContent: <LeftContestaciones/>,
          rightContent: <RightContestaciones/>,
        };
      case '/profile':
        return {
          mainContent: <MainConstestaciones/>,
          sidebarContent: 'Profile Links',
          rightContent: 'Profile Widgets',
        };
      default:
        return {
          mainContent: <MainConstestaciones view={view} senalTabla={signal}/>,
          sidebarContent: <LeftContestaciones signalTable={handleSignal}/>,
          rightContent: <RightGeneral sx={{ alignContent:'end'}} view={view} clicVista={funcionVista} />,
      };
    }
  };
  const pageData = getPageData(location.pathname);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', maxHeight: '100%',}} >
      <NavBar showLinks={false} showLoginButton={true} />
      <Stack direction="row" sx={{ flexGrow: 1, mt: 2}}>
        <Box sx={{display: 'flex', flexDirection: 'row', width: '100vw', height: '100vh', overflowY: 'auto',}} >
          <SelectedRowsProvider>
            {pageData.sidebarContent}
            {pageData.mainContent}
            {pageData.rightContent}
          </SelectedRowsProvider>
        </Box>
      </Stack>
    </Box>
  );
};

export default MainLayout;